import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header";
import Footer from "../layout/footer";

const bg = require("../../images/servicehero.png");

class SpecialCleaning extends Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Special Cleaning</h1>
                <div className="breadcrumb-row">
                  {/* <ul className="list-inline">
                    <li>
                      <Link  onClick={() => { window.scrollTo({ top: 0, left: 0, behavior: "auto" })}} to="/">Home</Link>
                    </li>
                    <li>Service</li>
                    <li>Service Details</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <div className="widget sidebar-widget ext-sidebar-menu widget_nav_menu">
                      <ul className="menu">
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/airbnb-cleaning"
                          >
                            Airbnb Property Management
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/residential-cleaning"
                          >
                            Residential Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/office-cleaning"
                          >
                            Office Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/school-and-medical-cleaning"
                          >
                            School And Medical Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/bond-cleaning"
                          >
                            Bond Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/window-cleaning"
                          >
                            Window Cleaning
                          </Link>{" "}
                        </li>
                        <li className="active">
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/special-event-cleaning"
                          >
                            Special Event Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/carpet-steam-cleaning"
                          >
                            Carpet Steam Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/spring-cleaning"
                          >
                            Spring Cleaning
                          </Link>{" "}
                        </li>
                      </ul>
                    </div>
                    {/* <div className="widget">
                      <div className="download-file">
                        <h4 className="title">Get your brochures</h4>
                        <ul>
                          <li>
                            <Link to="#" target="_blank">
                              <div className="text">Company Brochures</div>
                              <i className="fa fa-download"></i>
                            </Link>
                          </li>
                          <li>
                            <Link to="#" target="_blank">
                              <div className="text">Company Info</div>
                              <i className="fa fa-download"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        {/* <div className="dlab-media">
                            {" "}
                            <Link to="#">
                              <img
                                src={require("../../images/about/pic4.jpg")}
                                alt=""
                              />
                            </Link>{" "}
                          </div> */}
                        <div className="dlab-info ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Quick Pre and Post-Event Cleaning Services to
                              Throw-Up the Perfect Event in Gold Coast!
                            </Link>
                          </h4>
                          <p>
                            Organizing a special event is like multitasking at
                            once. Cleaning takes longer than arranging
                            everything from the food to the drinks to the decor.
                            Everything could fall apart if you're not organized.
                            Therefore, getting assistance with getting
                            everything done is necessary, whether throwing a
                            party, getting ready to have a new child,
                            celebrating, or organizing an event.
                          </p>
                        </div>
                        <div className="dlab-info m-t30 ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Benefits of Hiring a Professional Event Cleaning
                              Company
                            </Link>
                          </h4>
                          <p>
                            Professional special event cleaning services provide
                            a stress-free atmosphere by reducing the workload
                            you must do independently. Event cleaning companies
                            provide expert special indoor event cleaning,
                            outdoor event cleaning, and after-event cleaning
                            services, regardless of how big or small an event
                            could be. These professionals maintain the venue's
                            cleanliness before, during, and after the event.
                            They cover the bars, catering areas, restrooms,
                            trade stands, stages, welfare facilities, and
                            back-of-house areas and perform litter picking and
                            garbage disposal.
                          </p>
                          <p>
                            Special event cleaning services include, but are not
                            limited to the following:
                          </p>

                          <ul className="list-checked black">
                            <li>Complete management on-site</li>
                            <li>Daily cleaning service</li>
                            <li>Cleaning of shower and restroom facilities</li>
                            <li>
                              Provision of a large factory with personnel who
                              are trained in removing outsized locations
                            </li>
                            <li>Cleaning of seats</li>
                            <li>Floor maintenance</li>
                            <li>Scooping up trash</li>
                            <li>Waste management and disposal</li>
                          </ul>
                          <p>And post-event cleaning services include:</p>
                          <ul className="list-checked black">
                            <li>
                              Dishwashing supplies and other party equipment
                            </li>
                            <li>Reorganizing</li>
                            <li>
                              Cleaning all surfaces, vacuuming, and sanitation
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="dlab-box">
                      <div className="dlab-info m-t30">
                        <h4 className="dlab-title m-t0">
                          <Link to="#">
                            Why Choose Gold Coast Kangaroo Shine Property
                            Services in Gold Coast, Queensland?
                          </Link>
                        </h4>
                        <p>
                          Our team of professionals at Gold Coast Kangaroo Shine
                          Property Services in Gold Coast is experienced in
                          handling event cleaning for a variety of events
                          including:
                        </p>
                        <ul className="list-checked black">
                          <li>Musical events</li>
                          <li>Sports</li>
                          <li>Festivals</li>
                          <li>Business events</li>
                          <li>Hospitality</li>
                          <li>Grand openings</li>
                          <li>Weddings</li>
                        </ul>
                        <p>
                          We help you create a pleasant environment to ensure
                          guests receive the best welcome with wowed first
                          impressions. We work according to your preferences to
                          deliver the best outcomes before and after event
                          cleaning! If you live near Main Beach, Australia, and
                          are interested to discuss our customized packages at
                          Kangaroo Shine Property Services in Gold Coast, call
                          us at +61424888804
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
export default SpecialCleaning;
